export default [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
];

// export default {
// 	0: [{
// 		code: 81,
// 		value: 'q',
// 	}, {
// 		code: 87,
// 		value: 'w',
// 	}, {
// 		code: 69,
// 		value: 'e',
// 	}, {
// 		code: 82,
// 		value: 'r',
// 	}, {
// 		code: 84,
// 		value: 't',
// 	}, {
// 		code: 89,
// 		value: 'y',
// 	}]
// };
